import * as yup from "yup";
import {
  EMAIL_REGEX,
  nameRegex,
  phoneRegex,
} from "../../../helpers";

export const editAgentValidationSchema = yup.object().shape({
  firstName: yup
    .string()
    .matches(
      nameRegex,
      "Name must contain only letters and be at least 2 characters"
    )
    .required("Full name is required"),
  email: yup
    .string()
    .required("Email is required")
    .matches(
      EMAIL_REGEX,
      "Enter a valid email (e.g., user@example.com). Must not contain spaces, must include '@', and a valid domain."
    ),
  phoneNumber: yup
    .string()
    .matches(phoneRegex, "Enter a valid phone number")
    .required("Phone number is required"),
  roles: yup.string().notRequired(),
  address: yup.string().notRequired(),
});
